import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "raceFlag"
const RaceFlagIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="M9 6h2v2H9V6Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 3a1 1 0 0 1 2 0h7.001c.552 0 .999.443.999.999L20 4v10h-7.001A.997.997 0 0 1 12 13H6v9H4V3Zm3 3v2h2v2H7v2h2v-2h2v2h2v-2h-2V8h2V6h-2V4H9v2H7Zm10 3h2v2h-2V9Zm-2 0h2V7h2V5h-2v2h-2V5h-1v2h1v2Zm0 2h2v2h-2v-2Zm0 0V9h-1v2h1Z"
          />
        </svg>
      }
    </span>
  )
}
export default RaceFlagIcon
